module.exports = __webpack_public_path__ + "img/13.ec954025.jpg";